import { Link } from 'react-router-dom';
// Pointing to your jpeg logo based on your repository structure!
import logo2 from "../../assets/img/logo-2.png";

const SideBar = ({ isOpen, setIsOpen }) => {
    return (
        <>
            <div className={`header__area-menubar-right-sidebar-popup ${isOpen ? 'active' : ''}`}>
                <div className="sidebar-close-btn" onClick={() => setIsOpen(false)}><i className="fal fa-times"></i></div>
                <div className="header__area-menubar-right-sidebar-popup-logo">
                <Link to='/'>
                    {/* Make sure this path is perfectly correct for your logo */}
                    <img src={logo2} alt="Arclight Developers" />
                </Link>
                </div>
                <p>Redefining the civil engineering and construction industry with innovative infrastructure solutions and sustainable practices.</p>
                <div className="header__area-menubar-right-sidebar-popup-contact">
                    <h4 className="mb-30">Address</h4>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-phone"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>Phone:</span>
                            {/* Fixed the tel: link to match your number */}
                            <h6><a href="tel:+919909417333">+91 99094 17333</a></h6>
                            <h6><a href="tel:+919558554419">+91 95585 54419</a></h6>
                        </div>
                    </div>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-email-3"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>Email Address:</span>
                            {/* Fixed the mailto: link to match your email */}
                            <h6><a href="mailto:arclightdevelopers@gmail.com">arclightdevelopers@gmail.com</a></h6>
                        </div>
                    </div>
                    <div className="header__area-menubar-right-sidebar-popup-contact-item">
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-icon">
                            <i className="flaticon-location-1"></i>
                        </div>
                        <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                            <span>Location:</span>
                            {/* Added an actual Google Maps search link! */}
                            <h6><a href="#" target="_blank" rel="noopener noreferrer">Office Address:- 246/B, Purusangit Bunglow, Sector 7A, Gandhingar, Gujarat, 382007</a></h6>
                        </div>
                    </div>
                </div>
                
                {/* Social Component Removed from Here */}
                
            </div>
            {/* Added an onClick here so clicking the dark overlay also closes the menu */}
            <div className={`sidebar-overlay ${isOpen ? 'show' : ''}`} onClick={() => setIsOpen(false)}></div>
        </>
    );
};

export default SideBar;